import {createAction, props} from '@ngrx/store';
import {CartItem, CartItemInterface} from '../../data/model';
import {CommerceErrorInterface} from '../error-handling/commerce-error';
import {TaxEstimation} from '@sportngin/se-commerce-sdk';

export interface CartItemActionProps {
  item: CartItem;
  options?: {
    sync?: boolean;
  };
}

export interface CartTaxActionProps {
  tax: TaxEstimation;
}

export const setEnableCartSlideOut = createAction(
  '[Cart] Set enable Inline Cart Slide Out',
  props<{enabled: boolean}>(),
);

export const showCartSlideOut = createAction('[Cart] Show Cart Slide Out');

export const hideCartSlideOut = createAction('[Cart] Hide Cart Slide Out');

export const loadCart = createAction('[Cart] Load Cart');

export const loadCartSuccess = createAction(
  '[Cart] Load Cart Success',
  props<{cartItems: CartItem[]}>(),
);

export const loadCartFailure = createAction(
  '[Cart] Load Cart Failure',
  props<{error: CommerceErrorInterface}>(),
);

export const cartActionFailure = createAction(
  '[Cart] Cart Action Failure',
  props<{error: CommerceErrorInterface}>(),
);

export const cartSubmitFailure = createAction(
  '[Cart] Cart Submit Failure',
  props<{error: CommerceErrorInterface}>(),
);

export const addOrUpdateCartItem = createAction(
  '[Cart] Add or update cart item',
  props<CartItemActionProps>(),
);

export const addClareBundleToCart = createAction(
  '[Cart] Add Clare bundle lines',
  props<{
    items: CartItemInterface[];
    bundleDisplayName: string;
  }>(),
);

export const updateBundleItemsQuantity = createAction(
  '[Cart] Update Clare bundle quantity',
  props<{
    items: CartItem[];
    quantity: number;
    bundleDisplayName: string;
  }>(),
);

export const updateBundleItemsQuantitySuccess = createAction(
  '[Cart] Update Clare bundle quantity success',
  props<{
    items: CartItem[];
  }>(),
);

export const removeBundleItemsFromCart = createAction(
  '[Cart] Remove Clare bundle items',
  props<{
    items: CartItem[];
    bundleDisplayName: string;
  }>(),
);

export const addItemToCart = createAction(
  '[Cart] Add item',
  props<CartItemActionProps>(),
);

export const addItemToCartSuccess = createAction(
  '[Cart] Add item success',
  props<CartItemActionProps>(),
);

export const addItemToCartFailure = createAction(
  '[Cart] Add item failure',
  props<{item: CartItem; error: CommerceErrorInterface}>(),
);

export const retryAddCartItems = createAction(
  '[Cart] Retry Cart Items Request',
  props<{cartItems: CartItem[]}>(),
);

export const retryCartItemSuccess = createAction(
  '[Cart] Retry Cart Item Success',
  props<CartItemActionProps>(),
);

export const retryCartItemFailure = createAction(
  '[Cart] Retry Cart Item Failure',
  props<CartItemActionProps>(),
);

export const addItemToCartAndContinue = createAction(
  '[Cart] Add item and continue to next',
  props<CartItemActionProps>(),
);

export const addItemToCartAndRegisterAnother = createAction(
  '[Cart] Add item and register another person',
  props<CartItemActionProps>(),
);

export const removeItemFromCartThenRegisterAnother = createAction(
  '[Cart] Remove item then register another person',
  props<CartItemActionProps>(),
);

export const removeItemFromCartThenRegisterAnotherSuccess = createAction(
  '[Cart] Remove item then register another person',
  props<CartItemActionProps>(),
);

export const addItemToCartSuccessThenContinue = createAction(
  '[Cart] Add item and continue to next success',
  props<CartItemActionProps>(),
);

export const addItemToCartAndComplete = createAction(
  '[Cart] Add item to cart and complete',
  props<CartItemActionProps>(),
);

export const addItemToCartSuccessThenComplete = createAction(
  '[Cart] Add item to cart and complete success',
  props<CartItemActionProps>(),
);

export const addItemToCartSuccessAndRegisterAnother = createAction(
  '[Cart] Add item and register another person success',
  props<CartItemActionProps>(),
);

export const addItemToCartAndContinueToShipping = createAction(
  '[Cart] Add item and continue to shipping page',
  props<CartItemActionProps>(),
);

export const addItemToCartSuccessAndContinueToShipping = createAction(
  '[Cart] Add item and continue to shipping page success',
  props<CartItemActionProps>(),
);

export const removeCurrentAddonFromCartThenContinue = createAction(
  '[Cart] Remove current add-on from cart then continue',
);

export const removeCurrentAddonFromCartThenShipping = createAction(
  '[Cart] Remove current add-on from cart then shipping',
);

export const removeItemFromCartThenContinue = createAction(
  '[Cart] Remove item from cart then continue',
  props<CartItemActionProps>(),
);

export const removeItemFromCartSuccessThenContinue = createAction(
  '[Cart] Remove item from cart success then continue',
  props<CartItemActionProps>(),
);

export const removeItemFromCartThenShipping = createAction(
  '[Cart] Remove item from cart success then shipping',
  props<CartItemActionProps>(),
);

export const removeItemFromCartSuccessThenShipping = createAction(
  '[Cart] Remove item from cart success then shipping',
  props<CartItemActionProps>(),
);

export const removeCurrentAddonFromCartThenComplete = createAction(
  '[Cart] Remove current add-on from cart then complete',
);

export const removeItemFromCartThenComplete = createAction(
  '[Cart] Remove item from cart then complete',
  props<CartItemActionProps>(),
);

export const removeItemFromCartSuccessThenComplete = createAction(
  '[Cart] Remove item from cart success then complete',
  props<CartItemActionProps>(),
);

export const removeItemFromCart = createAction(
  '[Cart] Remove item',
  props<CartItemActionProps>(),
);

export const removeItemFromCartSuccess = createAction(
  '[Cart] Remove item success',
  props<CartItemActionProps>(),
);

export const updateCartItem = createAction(
  '[Cart] Update cart item',
  props<CartItemActionProps>(),
);

export const updateCartItemSuccess = createAction(
  '[Cart] Update cart item success',
  props<CartItemActionProps>(),
);

//region - Order actions -
export const completeOrder = createAction('[Order] Complete order');

export const completeOrderSuccess = createAction(
  '[Order] Complete order success',
);

export const registerAnotherPerson = createAction(
  '[Order] Register another person',
);
//endregion - Order actions -

export const navToFailedAddons = createAction(
  '[Cart] Navigate to Failed Add-ons page',
);

export const getCartTax = createAction('[Cart] Fetch Cart Tax');
export const getCartTaxSuccess = createAction(
  '[Cart] Fetch Cart Tax Success',
  props<CartTaxActionProps>(),
);
export const getCartTaxFailure = createAction(
  '[Cart] Fetch Cart Tax Failure',
  props<{error: CommerceErrorInterface}>(),
);
export const emptyCart = createAction('[Cart] Empty Cart');
export const clearFailedItems = createAction('[Cart] Clear Failed Items');

export const emptyCartSuccess = createAction('[Cart] Empty Cart Success');
export const emptyCartFailure = createAction(
  '[Cart] Empty Cart Failure',
  props<{error: CommerceErrorInterface}>(),
);
